/**
 * Golden L1: artist catalog fetch must not cap below real library size (2k-vs-4,392 bug).
 * Used by the enrichment catalog snapshot that backs artist portraits in the grid.
 */
export const ARTIST_CATALOG_FETCH_LIMIT = 100000;
